module.exports = __webpack_public_path__ + "img/coins.66d5fe88.png";